import Vue from "vue";
import {
  Button,
  Image as VanImage,
  Popup,
  Loading,
  Checkbox,
  Toast,
  Skeleton,
  NavBar,
  Dialog,
  Row,
  Col,
  Cell,
  CellGroup,
  Icon,
  Field,
  Form,
  Tabbar,
  Tab,
  Tabs,
  List,
  TabbarItem,
  PullRefresh,
  Progress,
  AddressEdit,
  Area,
  NoticeBar,
  Swipe,
  SwipeItem,
  CountDown,
  RadioGroup,
  CheckboxGroup,
  Radio,
  Stepper,
  Tag,
  ImagePreview,
  Overlay,
  Uploader,
  Rate,
  DropdownMenu,
  DropdownItem
} from "vant";
import "vant/lib/icon/local.css";
Vue.use(Button)
  .use(NavBar)
  .use(VanImage)
  .use(Popup)
  .use(Loading)
  .use(Checkbox)
  .use(Toast)
  .use(Skeleton)
  .use(Dialog)
  .use(Col)
  .use(Row)
  .use(Cell)
  .use(CellGroup)
  .use(Icon)
  .use(Field)
  .use(Form)
  .use(Tabbar)
  .use(Tab)
  .use(Tabs)
  .use(List)
  .use(TabbarItem)
  .use(PullRefresh)
  .use(AddressEdit)
  .use(Area)
  .use(Swipe)
  .use(SwipeItem)
  .use(CountDown)
  .use(Radio)
  .use(RadioGroup)
  .use(CheckboxGroup)
  .use(Progress)
  .use(Stepper)
  .use(Tag)
  .use(ImagePreview)
  .use(Overlay)
  .use(Uploader)
  .use(Rate)
  .use(DropdownMenu)
  .use(DropdownItem);



// WEBPACK FOOTER //
// ./src/utils/vant.js